import React from 'react'
import { INPUT_BASE } from './constants'
import { Label } from './Label'

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string; hint?: string; error?: string
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, hint, error, style, ...rest }, ref) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
      {label && <Label>{label}</Label>}
      <textarea ref={ref} style={{ ...INPUT_BASE, resize: 'vertical', lineHeight: 1.6, minHeight: '90px', ...(error ? { borderColor: 'var(--status-error)' } : {}), ...style }} {...rest} />
      {error && <span style={{ fontSize: '0.75rem', color: 'var(--status-error)' }}>{error}</span>}
      {hint && !error && <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{hint}</span>}
    </div>
  )
)
Textarea.displayName = 'Textarea'
